import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import './ChatPageSkeleton.css';

export const ChatBoardSkeleton: React.FC = () => (
  <div
    style={{
      height: 'calc(100vh - 160px)',
      background: '#fff',
      borderRadius: 15,
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
    }}
  >
    {/* Top bar */}
    <div
      style={{
        padding: '16px 20px',
        borderBottom: '1px solid #f0f0f0',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
    >
      <div className="d-flex align-items-center gap-3">
        <Skeleton circle width={50} height={50} />
        <div>
          <Skeleton width={130} height={16} borderRadius={6} style={{ marginBottom: 6 }} />
          <Skeleton width={70} height={12} borderRadius={6} />
        </div>
      </div>
      <div className="d-flex gap-2">
        <Skeleton width={34} height={34} borderRadius={6} />
        <Skeleton width={34} height={34} borderRadius={6} />
        <Skeleton width={34} height={34} borderRadius={6} />
      </div>
    </div>

    {/* Messages */}
    <div style={{ flex: 1, padding: '20px 16px', display: 'flex', flexDirection: 'column', gap: 16 }}>
      {[180, 220, 160].map((w, i) => (
        <div key={`l${i}`} className="d-flex align-items-end gap-2">
          <Skeleton circle width={36} height={36} style={{ flexShrink: 0 }} />
          <Skeleton width={w} height={40} borderRadius={12} />
        </div>
      ))}
      {[200, 160].map((w, i) => (
        <div key={`r${i}`} className="d-flex justify-content-end">
          <Skeleton width={w} height={40} borderRadius={12} />
        </div>
      ))}
      {[140, 190].map((w, i) => (
        <div key={`l2${i}`} className="d-flex align-items-end gap-2">
          <Skeleton circle width={36} height={36} style={{ flexShrink: 0 }} />
          <Skeleton width={w} height={40} borderRadius={12} />
        </div>
      ))}
    </div>

    {/* Input bar */}
    <div
      style={{
        padding: '12px 16px',
        borderTop: '1px solid #f0f0f0',
        display: 'flex',
        alignItems: 'center',
        gap: 10,
      }}
    >
      <Skeleton circle width={32} height={32} style={{ flexShrink: 0 }} />
      <Skeleton width="100%" height={44} borderRadius={22} />
      <Skeleton circle width={40} height={40} style={{ flexShrink: 0 }} />
    </div>
  </div>
);

/**
 * Mirrors Chats page exact layout:
 *  - Chat_Heading_Sec: "Inbox"
 *  - col-lg-4: Chat_Inbox_Main (search + new matches + chat list)
 *  - col-lg-8: chat area (header + messages + input)
 */
const ChatPageSkeleton: React.FC = () => (
  <div>
    {/* Heading */}
    <div className="Chat_Heading_Sec">
      <Skeleton width={80} height={28} borderRadius={6} />
    </div>

    <div className="col-lg-12 mt-3">
      <div className="row">
        {/* Left panel — col-lg-4 */}
        <div className="col-lg-4">
          <div className="Chat_Inbox_Main">
            <div className="Chat_Search_Main">
              {/* Search */}
              <div className="Chat_Search_Input_Sec">
                <Skeleton width="100%" height={40} borderRadius={8} />
              </div>
              {/* New Matches */}
              <div className="Inbox_New_Matches">
                <Skeleton width={110} height={18} borderRadius={6} style={{ marginBottom: 12 }} />
                <div className="d-flex gap-3 py-2 px-1">
                  {[...Array(4)].map((_, i) => (
                    <div key={i} className="d-flex flex-column align-items-center gap-1" style={{ minWidth: 64 }}>
                      <Skeleton circle width={60} height={60} />
                      <Skeleton width={50} height={10} borderRadius={6} />
                    </div>
                  ))}
                </div>
              </div>
            </div>
            {/* Chat list */}
            <div className="Inbox_Chat_List_Main">
              <div className="Inbox_Chat_Header">
                <Skeleton width={60} height={18} borderRadius={6} style={{ marginBottom: 12 }} />
              </div>
              <div className="Chat_List_Container">
                <div className="d-flex flex-column gap-3 p-2">
                  {[...Array(6)].map((_, i) => (
                    <div key={i} className="d-flex align-items-center gap-3">
                      <Skeleton circle width={50} height={50} style={{ flexShrink: 0 }} />
                      <div className="flex-grow-1">
                        <Skeleton width="60%" height={14} borderRadius={6} style={{ marginBottom: 6 }} />
                        <Skeleton width="80%" height={12} borderRadius={6} />
                      </div>
                      <Skeleton width={35} height={11} borderRadius={6} style={{ flexShrink: 0 }} />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Right panel — col-lg-8 */}
        <div className="col-lg-8">
          <ChatBoardSkeleton />
        </div>
      </div>
    </div>
  </div>
);

export default ChatPageSkeleton;
